import { StateCreator } from 'zustand';

export interface MapLayerSlice {
  mapInstance: any;
  setMapInstance: (val: any) => void;

  azureLayer: any;
  setAzureLayer: (val: any) => void;

  imageLayer: any;
  setImageLayer: (val: any) => void;

  boundsLayer: any;
  setBoundsLayer: (val: any) => void;

  placeLayer: any;
  setPlaceLayer: (val: any) => void;

  placeDrawLayer: any;
  setPlaceDrawLayer: (val: any) => void;

  gatewayLayer: any;
  setGatewayLayer: (val: any) => void;

  gatewayDrawLayer: any;
  setGatewayDrawLayer: (val: any) => void;

  stationaryLayer: any;
  setStationaryLayer: (val: any) => void;

  stationaryDrawLayer: any;
  setStationaryDrawLayer: (val: any) => void;

  scaleLayer: any;
  setScaleLayer: (val: any) => void;

  scaleDrawLayer: any;
  setScaleDrawLayer: (val: any) => void;

  assetLayer: any;
  setAssetLayer: (val: any) => void;

  assetRefLayer: any;
  setAssetRefLayer: (val: any) => void;

  placeRefLayer: any;
  setPlaceRefLayer: (val: any) => void;

  gatewayRefLayer: any;
  setGatewayRefLayer: (val: any) => void;

  stationaryRefLayer: any;
  setStationaryRefLayer: (val: any) => void;

  tempLayer: any;
  setTempLayer: (val: any) => void;
}

// --- Initial state for easy reset ---
export const mapLayerInitialState: Omit<
  MapLayerSlice,
  | 'setMapInstance'
  | 'setAzureLayer'
  | 'setImageLayer'
  | 'setBoundsLayer'
  | 'setPlaceLayer'
  | 'setPlaceDrawLayer'
  | 'setGatewayLayer'
  | 'setGatewayDrawLayer'
  | 'setStationaryLayer'
  | 'setStationaryDrawLayer'
  | 'setScaleLayer'
  | 'setScaleDrawLayer'
  | 'setAssetLayer'
  | 'setAssetRefLayer'
  | 'setPlaceRefLayer'
  | 'setGatewayRefLayer'
  | 'setStationaryRefLayer'
  | 'setTempLayer'
> = {
  mapInstance: null,
  azureLayer: null,
  imageLayer: null,
  boundsLayer: null,
  placeLayer: null,
  placeDrawLayer: null,
  gatewayLayer: null,
  gatewayDrawLayer: null,
  stationaryLayer: null,
  stationaryDrawLayer: null,
  scaleLayer: null,
  scaleDrawLayer: null,
  assetLayer: null,
  assetRefLayer: null,
  placeRefLayer: null,
  gatewayRefLayer: null,
  stationaryRefLayer: null,
  tempLayer: null,
};

export const createMapLayerSlice: StateCreator<MapLayerSlice> = (set) => ({
  ...mapLayerInitialState,

  setMapInstance: (val) => set({ mapInstance: val }),
  setAzureLayer: (val) => set({ azureLayer: val }),
  setImageLayer: (val) => set({ imageLayer: val }),
  setBoundsLayer: (val) => set({ boundsLayer: val }),
  setPlaceLayer: (val) => set({ placeLayer: val }),
  setPlaceDrawLayer: (val) => set({ placeDrawLayer: val }),
  setGatewayLayer: (val) => set({ gatewayLayer: val }),
  setGatewayDrawLayer: (val) => set({ gatewayDrawLayer: val }),
  setStationaryLayer: (val) => set({ stationaryLayer: val }),
  setStationaryDrawLayer: (val) => set({ stationaryDrawLayer: val }),
  setScaleLayer: (val) => set({ scaleLayer: val }),
  setScaleDrawLayer: (val) => set({ scaleDrawLayer: val }),
  setAssetLayer: (val) => set({ assetLayer: val }),
  setAssetRefLayer: (val) => set({ assetRefLayer: val }),
  setPlaceRefLayer: (val) => set({ placeRefLayer: val }),
  setGatewayRefLayer: (val) => set({ gatewayRefLayer: val }),
  setStationaryRefLayer: (val) => set({ stationaryRefLayer: val }),
  setTempLayer: (val) => set({ tempLayer: val }),
});
